import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      color: palette.text.secondary,
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      alignItems: 'center',
      marginTop: '30px',
      textAlign: 'center'
    },
    title: {
      fontSize: '1.5rem',
      color: palette.text.primary
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
